import { useState } from "react";
import AddCalendarDate from "./addCalendarDate";
import CalendarDateTable from "./calendarDateTable";

const CalendarManagement = ({ onBack }) => {
  const [activeView, setActiveView] = useState("table"); // "table" | "add"
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleAddSuccess = () => {
    setRefreshTrigger((prev) => prev + 1);
    setActiveView("table");
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
    marginBottom: "20px",
  };

  const headerStyle = {
    backgroundColor: "#f8f9fa",
    color: "#2c3e50",
    borderBottom: "2px solid #e9ecef",
    padding: "16px 20px",
    borderRadius: "12px 12px 0 0",
    fontWeight: "600",
    fontSize: "18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const backButtonStyle = {
    backgroundColor: "#6c757d",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  };

  const buttonStyle = {
    padding: "10px 20px",
    margin: "0 8px",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  const activeButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#007bff",
    color: "#ffffff",
  };

  const inactiveButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#e9ecef",
    color: "#495057",
  };

  if (activeView === "add") {
    return (
      <AddCalendarDate
        onBack={() => setActiveView("table")}
        onSuccess={handleAddSuccess}
      />
    );
  }

  return (
    <>
      <div style={cardStyle}>
        <div style={headerStyle}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <i className="fas fa-calendar-alt me-2"></i>
            Calendar Management
          </div>
          <button
            style={backButtonStyle}
            onClick={onBack}
            title="Back to Admin Dashboard"
          >
            <i className="fas fa-arrow-left"></i>
            Back
          </button>
        </div>
        <div style={{ padding: "20px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <button
              style={
                activeView === "table" ? activeButtonStyle : inactiveButtonStyle
              }
              onClick={() => setActiveView("table")}
            >
              <i className="fas fa-table"></i>
              View All Dates
            </button>
            <button
              style={
                activeView === "add" ? activeButtonStyle : inactiveButtonStyle
              }
              onClick={() => setActiveView("add")}
            >
              <i className="fas fa-plus"></i>
              Add New Date
            </button>
          </div>
        </div>
      </div>

      <CalendarDateTable refreshTrigger={refreshTrigger} />
    </>
  );
};

export default CalendarManagement;
